import { render, staticRenderFns } from "./Empirical.vue?vue&type=template&id=29f1525c&scoped=true"
import script from "./Empirical.vue?vue&type=script&lang=js"
export * from "./Empirical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f1525c",
  null
  
)

export default component.exports